import { CloseIcon } from 'components/icons';
import { defaultApiErrorSchema } from 'lib/api/utils';
import { useImpersonateUser } from 'lib/hooks/user/user.mutations';
import React from 'react';
import ReactModal from 'react-modal';
import { useHistory, useLocation } from 'react-router-dom';
import { Order } from '../RecentEsimOrdersList/RecentEsimOrdersList';

type ImpersonateConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  selectedOrder: Order | null;
};

function ImpersonateConfirmationModal({
  isOpen,
  onClose,
  selectedOrder,
}: ImpersonateConfirmationModalProps) {
  const [errorMessage, setErrorMessage] = React.useState('');
  const { isLoading, mutateAsync: impersonateUser } = useImpersonateUser();
  const history = useHistory();
  const location = useLocation();

  const closeModalHandler = () => {
    setErrorMessage('');
    onClose();
  };

  const impersonateUserHandler = async () => {
    if (!selectedOrder) return;

    setErrorMessage('');

    const { userId } = selectedOrder;

    try {
      const token = await impersonateUser({ userId });

      const jwtToken = localStorage.getItem('Authorization');

      if (jwtToken) {
        localStorage.setItem('i_Authorization', jwtToken);
        localStorage.setItem('Authorization', token);
      }

      closeModalHandler();

      localStorage.setItem('@lastActiveTab', location.pathname);

      history.push(
        selectedOrder.ordertype === 'spr'
          ? '/spr-orders'
          : selectedOrder.ordertype === 'fixed'
            ? '/fixed-orders'
            : '/eSIM-orders'
      );
    } catch (e) {
      const errorMessage =
        defaultApiErrorSchema.safeParse(e).data?.data?.message ??
        'Error trying to impersonate user';

      setErrorMessage(errorMessage);
    }
  };

  const isSubmitDisabled = isLoading || !selectedOrder;
  const { orderedBy } = selectedOrder || {};

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={closeModalHandler}
      ariaHideApp={false}
      contentLabel="Are you sure to impersonate?"
      portalClassName="react-modal"
      overlayClassName="modal"
      className="modal-dialog react-modal-dialog-sm modal-dialog-centered"
    >
      <div className="modal-content">
        <div className="react-modal-header">
          <h5 className="react-modal-title react-modal-title-md">
            Impersonate?
          </h5>

          <button
            type="button"
            className="btn react-modal-close"
            onClick={closeModalHandler}
          >
            <CloseIcon className={''} />
          </button>
        </div>

        <div className="react-modal-body">
          <p className="react-modal-subtitle">
            Are you sure you want to impersonate this user? <b>({orderedBy})</b>
          </p>

          {!!errorMessage && (
            <span className="invalid-feedback d-block mt-2">
              {errorMessage}
            </span>
          )}

          <div className="text-right">
            <button
              onClick={impersonateUserHandler}
              className="btn btn-dark btn-lg w-150 mt-3"
              disabled={isSubmitDisabled}
            >
              {isLoading ? 'Please Wait...' : 'Yes'}
            </button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
}

export default ImpersonateConfirmationModal;
